import { classNames } from "@op/opds.opux"
import React from "react"
import { ReactComponent } from "../svgs/illustration-insurance-category-travel.svg"

const IconCategoryTravel = ({ className, ...props }) => (
  <ReactComponent aria-hidden={true} {...props} className={classNames("insurance-icon", className)} />
)

IconCategoryTravel.displayName = "IconCategoryTravel"
export default IconCategoryTravel
